module.exports = __webpack_public_path__ + "media/images/web/landings/header-dedcd06c66207088a63b58731515b1a7.jpg";